// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","692":"IP"}[chunkId] + "." + {"594":"2e89f093","692":"095ef170"}[chunkId] + ".js";
};